module.exports = __webpack_public_path__ + "static/media/shi_white.c387c3e7.png";